<template>
    <div class="log-mapeamento">
        <b-modal
            ref="modalDetalheFluxoInfo"
            id="modal-log-mapeamento-retroativo"
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
            :title="`Log completo de ${logsModal.inicio} até ${logsModal.fim}`"
            tabindex="-1"
            @shown="openModal"
            @hide="closeModal"
            >
            <div class="cabecalho">
                Percentual do processamento:
                <el-progress :percentage="convertPercent(logsModal.porcentagemDoProcessamento)"></el-progress>
            </div>

            <el-table
                class="p-table"
                v-loading="loadingDetalhe"
                :data="logsModal.logs || []"
                style="width: 100%"
                stripe
                v-if="renderComponent"
                ref="tableMapeamentoLog"
                size="mini">

                <el-table-column
                    prop="competencia"
                    label="Competencia"
                    align="center"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="grupo"
                    label="Grupo"
                    align="left">
                </el-table-column>

                <el-table-column label="Valor">
                    <template slot="header" style="width:100%">
                        Valor
                        <el-checkbox class="mostrar-zerados" v-model="MostrarValoresZerados" @input="updateCheck" label="Mostrar zerados?" border size="mini"></el-checkbox>
                    </template>
                    <el-table-column
                        prop="valorFinancas"
                        label="Finanças"
                        align="center"
                        width="130">
                        <template slot-scope="scope" v-if="scope.row">
                            <span :class="formatClassColor(scope.row.valorFinancas)">
                                {{ toMoney(scope.row.valorFinancas) }}
                            </span>
                        </template>
                    </el-table-column> 

                    <el-table-column
                        prop="valorPainel"
                        label="Painel"
                        align="center"
                        width="130">
                        <template slot-scope="scope" v-if="scope.row">
                            <span :class="formatClassColor(scope.row.valorPainel)">
                                {{ toMoney(scope.row.valorPainel) }}
                            </span>
                        </template>
                    </el-table-column> 

                    <el-table-column
                        prop="valorDeDiferenca"
                        label="Diferença"
                        align="center"
                        width="130">
                        <template slot-scope="scope" v-if="scope.row">
                            <span :class="formatClassColor(scope.row.valorDeDiferenca)">
                                {{ toMoney(scope.row.valorDeDiferenca) }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column
                    fixed="right"
                    label="Status"
                    width="70"
                    align="center">
                    <template slot-scope="scope" v-if="scope.row">
                        <el-tooltip v-if="scope.row.status === 'Aguardando'" class="item" effect="dark" content="Status: Aguardando" placement="top-start">
                            <i class="fas fa-circle text-warning"></i>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.status === 'Processando'" class="item" effect="dark" content="Status: Processando" placement="top-start">
                            <i class="fas fa-circle text-primary"></i>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.status === 'Finalizado'" class="item" effect="dark" content="Status: Finalizado" placement="top-start">
                            <i class="fas fa-circle text-success"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>

                
                <template v-slot:append>
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__footer">
                        <colgroup>
                            <col name="el-table_10_column_49" width="100">
                            <col name="el-table_10_column_50" width="205">
                            <col name="el-table_10_column_51_column_52" width="130">
                            <col name="el-table_10_column_51_column_53" width="130">
                            <col name="el-table_10_column_51_column_54" width="130">
                            <col name="el-table_10_column_55" width="70"><col name="gutter" width="0">
                        </colgroup>
                        <tbody class="has-gutter">
                            <tr style="background-color: #f1f1f1; font-weight:900">
                                <td colspan="1" rowspan="2" class="el-table_10_column_49 is-center is-leaf el-table__cell">
                                    <div class="cell">Total</div>
                                </td>
                                <td colspan="1" rowspan="2" class="el-table_10_column_50 is-left is-leaf el-table__cell">
                                    <div class="cell"></div>
                                </td>
                                <td colspan="1" rowspan="1" class="el-table_10_column_51_column_52 is-center is-leaf el-table__cell">
                                    <div :class="`cell ${formatClassColor(logsModal.valorFinancas)}`">{{ toMoney(logsModal.valorFinancas) }}</div>
                                </td>
                                <td colspan="1" rowspan="1" class="el-table_10_column_51_column_53 is-center is-leaf el-table__cell">
                                    <div :class="`cell ${formatClassColor(logsModal.valorPainel)}`">{{ toMoney(logsModal.valorPainel) }}</div>
                                </td>
                                <td colspan="1" rowspan="1" class="el-table_10_column_51_column_54 is-center is-leaf el-table__cell">
                                    <div :class="`cell ${formatClassColor(logsModal.valorDeDiferenca)}`">{{ toMoney(logsModal.valorDeDiferenca) }}</div>
                                </td>
                                <td colspan="1" rowspan="2" class="el-table_10_column_55 is-center is-hidden is-leaf el-table__cell">
                                        <div class="cell"></div>
                                </td>
                                <th class="el-table__cell gutter" style="width: 0px; display: none;"></th>
                            </tr>
                        </tbody>
                    </table>
                </template>
                
            </el-table>
            <br>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="pagination.pageSize"
                :current-page.sync="pagination.page"
                layout="sizes, prev, pager, next"
                background
                class="text-center"
                :total="pagination.total"
                >
            </el-pagination>
            <template #modal-footer="{ hide }">
                <div class="left-btn">
                    <el-button v-if="temAcesso('Comparativo','Exportar')" size="small" type="success" icon="el-icon-download" @click="exportarDetalhes" :loading="loadingExportar">Exportar Inconsistências</el-button>
                    <el-button v-else size="small" type="success" icon="el-icon-download"  v-b-tooltip.hover title="Sem permissões" class="no-drop">Exportar</el-button>
                </div>
                <div class="float-right">
                    <el-button size="small" @click="hide()">Fechar</el-button>
                </div>
			</template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'detalhe-fluxo-caixa',
        props: {
            datas: { type: Object }
        },
        data() {
            return {
                loadingDetalhe: false,
                loadingExportar: false,
                MostrarValoresZerados: false,
                renderComponent: true,
                logsModal: {},
                rowTemp: {},
                empresaId: '',
                interval: '',
                pagination: {
                    page: 1,
                    pageSize: 25,
                    total: 0
                }
            }
        },
        methods: {
            handleSizeChange(val) {
                this.pagination.pageSize = val
                this.pagination.page = 1
                this.getDetalhe(this.datas.id)
            },
            updateCheck(item){
                const ctx = this
                //this.MostrarValoresZerados = item
                ctx.renderComponent = false
                
                ctx.$nextTick(() => {
                    this.getDetalhe(this.datas.id)
                    ctx.renderComponent = true
                })
            },
            handleCurrentChange(val) {
                this.pagination.page = val
                this.getDetalhe(this.datas.id)
            },
            toMoney(num){ // FORMATA REAL
                let n = num ? num : 0;
                return n ? Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
            },
            convertPercent(percent) {
                const splited = percent ? percent.split(' ') : []
                if(!splited.length) {
                    return 0
                }
                const num = parseFloat(splited[0])
                return num
            },
            formatClassColor(num){
                let n = num ? num : 0;
                return n >= 0 ? 'positive' : 'negative';
            },
            openModal() {
                const ctx = this
                if(!ctx.datas.id){
                    return
                }
                ctx.getDetalhe(ctx.datas.id)
                this.loadingDetalhe = true
            },
            closeModal() {
                //clearInterval(this.interval)
            },
            async getDetalhe(model) { 
                
                this.rowTemp = this.datas
                try {
                    
                    const response = await this.axios.get(this.$urls.GET_COMPARATIVO_POR_ID, {
                        params: {
                            id: this.rowTemp.id,
                            MostrarValoresZerados: this.MostrarValoresZerados,
                            Page: this.pagination.page,
                            PageSize: this.pagination.pageSize
                        }
                    });

                    if(response.status !== 200) {
                        this.$notify.error({
                            title: 'Obter detalhe',
                            message: `Não foi possível obter log detalhado`,
                            position:'top-left'
                        });
                        return
                    }
                    this.logsModal = response.data
                    this.pagination.total = response.data.qtdeLogs
                    
                    if(this.convertPercent(response.data.porcentagemDoProcessamento) === 100) {
                        clearInterval(this.interval)
                    }

                } catch(err) {
                    this.$notify.error({
                            title: 'Erro interno',
                            message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                            position:'top-left'
                        });
                } finally {
                    this.loadingDetalhe = false
                }
            },
            async exportarDetalhes() { 
                this.loadingExportar = true
                try {
                    const response = await this.axios.post(this.$urls.EXPORTAR_COMPARATIVO, {
                        id: this.rowTemp.id
                    });

                    if(response.status !== 200) {
                        this.$notify.error({
                            title: 'Exportar detalhe',
                            message: `Não foi possível Exportar o Log detalhado`,
                            position:'top-left'
                        });
                        return
                    }
                    this.$notify({
                        type: "success",
                        title: 'Gerando Relatório',
                        dangerouslyUseHTMLString: true,
                        message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
                    });

                } catch(err) {
                    this.$notify.error({
                            title: 'Erro interno',
                            message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                            position:'top-left'
                        });
                } finally {
                    this.loadingExportar = false
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .det-header {
        width:100%;
    }
    .left-btn {
        position: absolute; 
        left: 15px;
    }
    .cabecalho {
        margin-bottom: 5px;
    }
    .mostrar-zerados {
        position: absolute;
        right: 4px;
        top: 2px;
        padding-bottom: 25px !important;
    }
</style>
<style lang="scss">
    .log-mapeamento {
        .el-collapse-item__content {
            background: #f7f7f7;
            padding: 10px;
        }
        .el-table__footer-wrapper {
            font-weight: 900;
        }
    }
    #modal-log-mapeamento-retroativo{
        span.positive,.cell.positive {
            color:#28a745 !important;
        }
        span.negative,.cell.negative {
            color:#dc3545 !important;
        }
        tbody.has-gutter td {
            font-weight: 900;
        }
        .el-table .cell {
            max-width: 100% !important;
        }
    }
    .p-table {
        tr.el-table__row td.el-table__cell {
            background: #fff;
        }
        tr.el-table__row:hover td.el-table__cell {
            background: #f5faff !important;
        }
        thead tr th {
            box-shadow: 0px 0px 1px 0px #898989 !important;
        }
    }
</style>